import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersBusinessSectionEmployeeSurveysIndexRequestType,
  ApiMembersBusinessSectionEmployeeSurveysIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiMembersBusinessSectionEmployeeSurveysIndexRequestType;
  businessSectionId: string;
  page?: number;
};

const request = async ({
  params,
  businessSectionId,
  page = 1,
}: RequestDataType): Promise<ApiMembersBusinessSectionEmployeeSurveysIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersBusinessSectionEmployeeSurveysIndexResponseType>(
      `/api/members/business_sections/${businessSectionId}/employee_surveys`,
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  businessSectionId: string;
  params?: ApiMembersBusinessSectionEmployeeSurveysIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersBusinessSectionsEmployeeSurveysIndex = ({
  businessSectionId,
  params,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMembersBusinessSectionEmployeeSurveysIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    [
      "ApisMembersBusinessSectionsEmployeeSurveysIndex",
      businessSectionId,
      params,
    ],
    ({ pageParam }) => {
      return request({
        businessSectionId,
        params,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
